<template>
  <FormulateForm @submit="submitForm">
  <div class="container mt-4">
    
    <b-card class="mb-4">
      <b-card-header>Créez Votre compte (Tous les champs sont obligatoires)</b-card-header>
      <b-card-body>
        
          <FormulateInput
            type="text"
            name="name"
            label="Prénom NOM"
            validation="required"
            placeholder="Entrez votre nom complet"
          />

          <FormulateInput
            type="text"
            name="phone"
            label="Téléphone portable"
            validation="required"
            placeholder="06 00 00 00 00"
          />

          <FormulateInput
            type="email"
            name="email"
            label="Email"
            validation="required|email"
            placeholder="email@societe.fr"
            v-model="email"
          />
          <div class="text-muted">
            Vous recevrez sur cet email, les instructions pour activer votre compte.
          </div>

          
        
      </b-card-body>
    </b-card>

    <b-card class="mb-4">
      <b-card-header>Votre société</b-card-header>
      <b-card-body>

        <AutoComplete
          :suggestions="companyOptions"
          @input-change="fetchCompanies"
          select="handleSelect"
          v-model = "selectedCompany"
          placeholder="Saisissez pour chercher..."
          />

        <FormulateInput
          type="hidden"
          name="company.id"
          v-model="selectedCompanyId"
        />

        <div v-if="showCompanySection" >

        <FormulateInput
          type="text"
          name="company.name"
          label="Nom de votre société"
          validation="required"
          placeholder="SOCIETE"
        />

        <FormulateInput
          type="textarea"
          name="company.address"
          label="Adresse"
          validation="required"
          placeholder="10 rue des Martins
CEDEX 6"
        />

        <FormulateInput
          type="number"
          name="company.zip"
          label="Code postal"
          validation="required"
          placeholder="12345"
        />

        <FormulateInput
          type="text"
          name="company.city"
          label="Ville"
          validation="required"
          placeholder="Ville"
        />
        </div>
      </b-card-body>
    </b-card>

    <b-button
      type="submit"
      variant="primary"
      class="w-100"
      :disabled="!canSubmit"
    >
      Submit
    </b-button>
  </div>
</FormulateForm>
</template>

<script>
export default {
  data() {
    return {
      companies: [],
      selectedCompany: null,
      selectedCompanyId: null,
      showCompanySection: false,
      companyName: '',
      email: ''
    };
  },
  computed: {
    companyOptions() {
      return [
      { value: null, label: '--Autre Société--' },
      ...this.companies.map(company => ({ value: company.id, label: company.name + " - " + company.zip + "-" + company.city })),
      ];
    },
    canSubmit() {
      return this.selectedCompany !== null;
    }
  },
  methods: {
    async fetchCompanies(input) {
      //const emailOrCompanyName = event.target.value;
      try {
        if(!input || input.length <= 2 ) return
        //console.log(input)
        let url = `/user/companies?email=${encodeURIComponent(this.email)}&companyname=${encodeURIComponent(input)}`;
        //console.log("url", url)
        let response = await this.$http.get(url);
        //console.log("fetchCompanies: DATA", response)
        this.companies = await response.data.companies;
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    },
    async submitForm(values) {
      console.log('Form values:', values);
      
      let url = `/user/register`;
      console.log("url", url)
      
      try {
        let response = await this.$http.post(url, values);
        await swal({
              title: "Inscription terminée",
              text: `Vérifiez votre messagerie ${values.email}`,
              icon: "success"
            });
        this.$router.push('/')
      } catch (err) {
        console.error("Erreur lors de l'enregistrement", url, err);
        swal("Erreur lors de l'enregistrement", JSON.stringify( err.response ? err.response.data : err.message), "error");
      }
    }
  },
  watch: {
    selectedCompany(company) {
      //console.log("selectedCompany", company)
      this.selectedCompanyId = company.value
      if (!company.value) {
        this.showCompanySection = true;
      } else {
        this.showCompanySection = false;
      }
    }
  }
};
</script>

<style>
.container {
  max-width: 600px;
  margin: auto;
}
</style>